import script from "./h5Preview.vue?vue&type=script&setup=true&lang=ts"
export * from "./h5Preview.vue?vue&type=script&setup=true&lang=ts"

import "./h5Preview.vue?vue&type=style&index=0&id=6690f0e6&lang=less&scoped=true"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6690f0e6"]])

export default __exports__